import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, INITIALTOKEN, StaggingURL } from "../../utils/app-constants";
import {
  EmptyLocalStorage,
  GetTokenFromLocalStorage,
} from "../../utils/helper";

const baseQuery = fetchBaseQuery({
  baseUrl: StaggingURL,
  credentials: "same-origin",
  prepareHeaders: async (headers) => {
    headers.set("authorization", `Bearer ${GetTokenFromLocalStorage()}`);
    headers.set("token", INITIALTOKEN);
    headers.set("Accept", "*/*");
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    EmptyLocalStorage();
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({}),
});
